const i = {
    CustomEvent: "ce",
    Pr: "p",
    Eu: "pc",
    vc: "ca",
    Ka: "i",
    qs: "ie",
    M: "cci",
    R: "ccic",
    I: "ccc",
    F: "ccd",
    ql: "ss",
    xl: "se",
    Gi: "si",
    $i: "sc",
    Ei: "sbc",
    Cc: "sfe",
    mo: "iec",
    Bu: "lr",
    _u: "uae",
    O: "ci",
    $: "cc",
    Wu: "lcaa",
    Ku: "lcar",
    On: "inc",
    Ln: "add",
    Rn: "rem",
    $n: "set",
    Bn: "ncam",
    Gu: "sgu",
    Fr: "ffi",
  },
  or = { Ar: "feed_displayed", Ec: "content_cards_displayed" };
export { i as EventTypes, or as InternalEventTypes };
